<ng-container *ngIf="!!get">
    <tt-page>
        <ng-container *ngIf="!('mobile' | mediaQuery)">
            <tt-divider ttRememberId="orderheads.divider">
                <tt-divider-rows>
                    <tt-divider-pane ttSize="50">
                        <tt-divider-columns>
                            <tt-divider-pane ttSize="25">
                                <tt-order-heads-filter [(get)]="get" (getChange)="readOrderHeadsGrid()"></tt-order-heads-filter>
                            </tt-divider-pane>
                            <tt-divider-pane ttSize="75">
                                <tt-grid
                                    *ngIf="!!orderHeadsGrid"
                                    [(ttOptions)]="orderHeadsGrid"
                                    ttRowSelection
                                    (ttOnRowSelected)="onOrderHeadSelected($event)"
                                    (ttReady)="onOrderHeadsGridReady()"
                                ></tt-grid>
                            </tt-divider-pane>
                        </tt-divider-columns>
                    </tt-divider-pane>
                    <tt-divider-pane ttSize="50">
                        <tt-order-lines-grid *ngIf="'' + get.selected_order_internal_no > '0'" [params]="orderLinesParams" (gridReady)="orderLinesGrid = $event"></tt-order-lines-grid>
                    </tt-divider-pane>
                </tt-divider-rows>
            </tt-divider>
        </ng-container>
        <ng-container *ngIf="'mobile' | mediaQuery">
            <tt-order-heads-filter [(get)]="get" (getChange)="paged.loadOrderHeads()"></tt-order-heads-filter>
            <tt-order-heads-paged #paged [params]="get"></tt-order-heads-paged>
        </ng-container>
        <tt-card *ngIf="get.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </tt-page>
</ng-container>
